"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
/**
 * This is the component used to render the content inside of a Section component.
 *
 * @example Rendering simple SectionContent
 * ```typescript
 *
 *    <SectionContent>
 *        <div> You can put and component you want to render here </div>
 *    </SectionContent>
 * ```
 *
 * @example Rendering simple SectionContent with disabled gutters
 * ```typescript
 *
 *    <Section.Content disableGutters={true}>
 *        <div> You can put and component you want to render here </div>
 *    </Section.Content>
 * ```
 * @category component
 */
const SectionContent = (props) => {
    const { disableGutters = false, children, ...restProps } = props;
    return (react_1.default.createElement(Box_1.default, { sx: {
            overflowWrap: "break-word",
            p: (theme) => (disableGutters ? theme.spacing(2, 0) : 2),
        }, ...restProps }, children));
};
exports.default = SectionContent;
